module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (6).b15cc331.jpg";